import { type Meta } from '../types/docs';

const META: Meta = {
  description:
    'Next-action pills (animate, remove background, change lighting, stylize) were shown on the chat follow-up card after a smart resize. Denominator for canvas_node_tool_opened with location next_action_pill.',
  name: 'canvas_next_action_pills_shown',
  params: [
    {
      description: 'The id of the canvas',
      name: 'canvas_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The pills that were shown, in display order',
      name: 'pill_ids',
      required: true,
      type: 'array',
      values: ['animate', 'remove_background', 'change_lighting', 'stylize'],
    },
  ],
};

export default META;
